import { get, post } from '@api/request';

export async function fetchAppraiserTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Property&name=Appraiser Type`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraiserSettings(
  { appraisalService },
  authenticationToken,
  { propType },
) {
  const url = `${appraisalService}/appraisal/appraisersettings/${propType}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertAppraiserSettings(
  { appraisalService },
  authenticationToken,
  { propType, payload },
) {
  const url = `${appraisalService}/appraisal/appraisersettings/${propType}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}
